module.exports = __webpack_public_path__ + "static/media/frente_INEjpg.8adf18b4.jpg";